import {Lightbulb} from 'lucide-react';

import {cn} from '../../lib/utils';
import {Typography} from '../Typography';

import type {ReactNode} from 'react';

export interface TipProps {
  title: ReactNode;
  description?: ReactNode;
  className?: string;
}

export function Tip({title, description, className}: TipProps) {
  return (
    <div
      data-slot="tip"
      className={cn(
        'flex items-start gap-2 rounded-lg border border-border-subtle bg-background-secondary p-3',
        className
      )}
    >
      {/* Icon — visually on the inline-start side (right in RTL) */}
      <Lightbulb className="mt-0.5 size-5 shrink-0 text-fg" />

      {/* Text group */}
      <div className="flex flex-1 flex-col gap-0.5">
        <Typography size="xs" weight="semibold">
          {title}
        </Typography>
        {description && (
          <Typography size="xs" color="secondary">
            {description}
          </Typography>
        )}
      </div>
    </div>
  );
}
